export default __webpack_public_path__ + "static/media/number_3.c90b8b8c.svg";